// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

/* eslint max-lines: 0 */

import { mapState, mapActions } from 'vuex';
import { reactive } from 'vue';
import apiService from '../../../../share/util/api/service';
import handler from '../../../../share/util/apiResultValidator';
import customTable from '../../../../share/components/vue/PaginationTable';
import util from '../../../../share/util/utils';
import vehicle from '../../../../share/util/vehicle';
import loading from '../../../../share/components/vue/ProcessingIcon';
import noTextSVGButton, { ICON_KEY, BUTTON_TYPE } from "../../../../share/components/vue/NoTextSVGButton";
import diagnoseResource from '../../../../share/util/diagnose';
import detailDtcModal from '../../../vue/DetailDTCModal';
import detailMonitorTestModal from '../../../vue/DetailMonitorTestModal';
import dataMonitorMeasure from '../../../vue/dataMonitor/DataMonitorMeasure';
import dmUtil from "../../dataMonitor/dataMonitorUtil";
import { createZoomTabHandlersForOptions, isResetZoomDisabled } from '../../dataMonitor/dataMonitorZoomUtil';
import DataMonitor from '../../individualWorkSupport/requirement045/Requirement045DataMonitor';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import alert from '../../../../share/alert';
import { getMidTidPairs } from '../../individualWorkSupport/requirement045/api/Requirement045Utils';
import { getCsvFileName } from '../../../../util/fileExport';
const moment = require('moment');

const WS45 = 4501;
const WS96 = 9601;
const WS125 = 12501;
const WS138 = 13801;
const WS139 = 13901;
const WS148 = 14801;
const WS172 = 17201;
const ES9 = 901;

// (WS.45) モニタテスト表示対象
const MID_TID_PAIRS = getMidTidPairs(true); // プレフィックスありで取得

// (WS.125) モニタテスト表示対象DTC
const MONITOR_TEST_DTC = [
  "P2DDA09",
  "P043F00",
  "P043E00",
  "P24BD71",
  "P00FE9C",
  "P045500",
  "P045600",
  "P04AB07",
  "P241872",
  "P241873",
  "P04ED00",
  "P04EF00",
  "P04EC00",
  "P04EE00"
];

// (WS.45) CSVエクスポート用
const DIAG_SYSTEM = 'diagSytem.';
const CSV = {
  LINE_BREAK: '\r\n',
  ECU_DECORATION: '################'
};

/** (WS.45) DTCモーダル画面各フェーズ定義 */
const DTC_MODAL_PHASE = {
  DTC_DISPLAY: 'dtcDisplay',
  DETAILED_FFD: 'detailedFfd',
  READINESS_CODE_DISPLAY: 'readinessCodeDisplay'
};

export default {
  name: "workSupportPage",
  data() {
    return {
      processing: false,
      recollectedData: [],
      measuredDataColumns: [],
      measuredDataItems: [],
      projectId: "",
      measuresId: "",
      linkedIds: {},
      system: "",
      immutableId: null,
      i18nWsKey: "",
      i18nWsDidKey: ``,                            // wsDidのi18nキー
      isWs45: false,                               // (WS.45) WS.45か否か
      isMonitorTest: false,                        // (WS.45) モニタテスト結果表示モーダル表示フラグ
      getMonitorTestDataResponse: null,            // (WS.45) モニタテスト結果
      filteredMonitorTestResult: [],                // (WS.45) 表示対象のみでフィルタしたモニタテスト結果
      dtcModalPhase: DTC_MODAL_PHASE.DTC_DISPLAY,  // (WS.45) DTCモーダルフェイズ
      dtcModalDataPlayback: true,
      isDetailDtc: false,                          // (WS.45) DTC結果表示モーダル表示フラグ
      isMonitorTestInitial: true,                  // (WS.45) モニタテスト結果取得初回フラグ
      isDiagInitial: true,                         // (WS.45) DTC取得結果取得初回フラグ
      isSBRUser: false,                            // SBRユーザー該否
      WS138: {
        enabled: false,                            // (WS.138) WS.138か否か
        title: '',                                 // (WS.138) タイトル文言
        logDataList: null,                         // (WS.138) ログ取得結果一覧
        filePath: '',                              // (WS.138) ダウンロードファイルパス
        fileExists: false                          // (WS.138) ダウンロードファイルが存在するか否か
      },
      WS148: {
        enabled: false,                            // (WS.148) WS.148か否か
        title: '',                                 // (WS.148) タイトル文言
        logDataList: null,                         // (WS.148) ログ取得結果一覧
        filePath: '',                              // (WS.148) ダウンロードファイルパス
        fileExists: false                          // (WS.148) ダウンロードファイルが存在するか否か
      },
      isWs172: false,                              // (WS.172) WS.172か否か
      ws172TableRenderKey: 0,                      // (WS.172) テーブル再描画キー
      dataMonitor: null,                           // (WS.45) RecollectionDataMonitorクラスのインスタンス
      // data-monitor-measure用変数
      inExecution: false,
      inPlaying: true,
      isZoomPanActive: false,
      currentTab: dmUtil.TAB.LIST,
      isCompleted: false,
      savedMarkerInfo: [],
      ws45MarkerInfo: {},
      isSpecial: false,                            // 特殊機能か否か
      ICON_KEY: ICON_KEY,                          // SVGアイコンの種類
      BUTTON_TYPE: BUTTON_TYPE,                    // SVGアイコンのボタンの種類
    };
  },

  watch: {
    language() {
      this.updateColumns();
    },
  },

  components: {
    'custom-table': customTable,
    'processing-view': loading,
    'data-monitor-measure': dataMonitorMeasure,
    'detail-dtc-modal': detailDtcModal,
    'detail-monitor-test-modal': detailMonitorTestModal,
    "no-text-svg-button": noTextSVGButton,
  },

  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('fileResources', ['checkSBRUser']),
    ...createZoomTabHandlersForOptions({
      dataMonitorRefKey: 'data_monitor_measure',
      isResetZoomDisabled() {
        return this.isResetZoomButtonDisable;
      },
    }),

    /**
     * 作業サポート一覧取得
     * @param {String} projectId プロジェクトID
     * @param {String} measuresId 計測データID
     * @param {String} system ECU名
     * @param {Number} immutableId 不変ID
     * @param {Boolean} isSpecial 特殊機能フラグ
     */
    async createWorkSupportMeasuresList(projectId, measuresId, system, immutableId, isSpecial) {
      try {
        this.processing = true;
        this.projectId = projectId;
        this.measuresId = measuresId;
        this.system = system;
        const workSupportEndPoint = '/workSupports/' + projectId + '/' + measuresId;
        const params = { region_info: this.cachedProjectDataSource };
        const resWorkSupport = await apiService.getParamCall(apiService.WSP, workSupportEndPoint, params, null);

        handler.validate(handler.validateTypes.all, resWorkSupport, this, null, async () => {
          // 通常機能と特殊機能でキー名を分ける
          this.i18nWsKey = isSpecial ? `spws${system}.${immutableId}` : `ws${system}.${immutableId}`;
          this.i18nWsDidKey = `wsDid${system}`;
          this.immutableId = immutableId;
          this.isSpecial = isSpecial;
          this.updateColumns();

          // immutable_idで処理を分岐
          switch (this.immutableId) {
            case WS45:
            case WS125: {
              // 各変数初期化
              this.isDiagInitial = true;
              this.inPlaying = true;
              this.isCompleted = false;
              this.dataMonitor = null;
              this.dataMonitor = reactive(new DataMonitor(this, "play"));
              this.isWs45 = true; // データモニタ表示
              this.recollectedData = resWorkSupport.data.project.data_monitor_list;
              this.linkedIds = resWorkSupport.data.project.linked_id;
              this.ws45MarkerInfo = {
                projectId: this.projectId,
                baseTime: Math.floor(Number(this.recollectedData[0].data_records[0].time)),
                measuredTimes: this.recollectedData[0].data_records.map(data => Number(data.time)),
              };
              if (!this.isCompleted) {
                this.dataMonitor.specifiedSystemId = system;
                await this.dataMonitor.update(this.recollectedData, null);
                // inPlaying の変更前には savedMarkerInfo 情報を設定する
                this.savedMarkerInfo = this.dataMonitor.createMarkerDetails(resWorkSupport.data.project.comments || [], this.userId);
                this.inPlaying = false;
                this.$nextTick(() => {
                  this.$refs.data_monitor_measure.selectedTab = 2;
                });
              }
              this.isCompleted = true;
              break;
            }
            case WS138: {
              this.WS138.enabled = true; // テーブル・ファイルエクスポートボタン非表示、ログデータ・ダウンロードボタン表示
              // タイトル表示
              this.WS138.title = this.$t(`${this.i18nWsKey}.REQ_WS_138_TXT_4`);
              // ダウンロードファイルパス
              this.WS138.filePath = resWorkSupport.data.project.file_path;
              // ログデータ取得結果の一覧表示用のデータ編集
              const datalist = resWorkSupport.data.project.ws138_log_data;
              this.WS138.logDataList = datalist.map((item) => {
                const logNo = item.timestamp ? this.$t(`${this.i18nWsKey}.label_log_number`, [item.number]) : "";
                const updateStatus = item.upload_status === 'completed' ? this.$t('message.common_title_success') : this.$t('message.common_title_failure');
                const logTimestamp = item.timestamp ? `(${item.timestamp})` : "";
                return {
                  results: `${logNo} ${updateStatus} ${logTimestamp}`, // 連結表示（No、成否、期間）
                };
              });
              // ダウンロードファイルパスにファイルが存在するか否か
              this.WS138.fileExists = resWorkSupport.data.project.file_exists;
              break;
            }
            case WS148: {
              this.WS148.enabled = true; // テーブル・ファイルエクスポートボタン非表示、ログデータ・ダウンロードボタン表示
              // タイトル表示
              this.WS148.title = this.$t(`${this.i18nWsKey}.REQ_WS_148_TXT_4`);
              // ダウンロードファイルパス
              this.WS148.filePath = resWorkSupport.data.project.file_path;
              // ログデータ取得結果の一覧表示用のデータ編集
              const datalist = resWorkSupport.data.project.ws148_log_data;
              this.WS148.logDataList = datalist.map((item) => {
                const logNo = item.timestamp ? this.$t(`${this.i18nWsKey}.label_log_number`, [item.number]) : "";
                const updateStatus = item.upload_status === 'completed' ? this.$t('message.common_title_success') : this.$t('message.common_title_failure');
                const logTimestamp = item.timestamp ? `(${item.timestamp})` : "";
                return {
                  results: `${logNo} ${updateStatus} ${logTimestamp}`, // 連結表示（No、成否、期間）
                };
              });
              // ダウンロードファイルパスにファイルが存在するか否か
              this.WS148.fileExists = resWorkSupport.data.project.file_exists;
              break;
            }
            case WS139: {
              this.recollectedData = resWorkSupport.data.project.operation_histories;
              const convertedData = this.recollectedData.map((history, index) => {
                const isRegistrationFailureTiming = history.type === 'registration_failure_timing';
                return {
                  sort_index: index, // ソート用に保持
                  did: this.$t(`${this.i18nWsDidKey}.${history.did}`),
                  unit: this.$t(`didUnit.${history.unit}`),
                  is_registration_failure_timing: isRegistrationFailureTiming,
                  history_1: isRegistrationFailureTiming ? this.convertLocalDateTime(history.data_records[0]) : history.data_records[0],
                  history_2: isRegistrationFailureTiming ? this.convertLocalDateTime(history.data_records[1]) : history.data_records[1],
                  history_3: isRegistrationFailureTiming ? this.convertLocalDateTime(history.data_records[2]) : history.data_records[2],
                };
              });
              this.$nextTick(() => {
                this.measuredDataItems = convertedData;
              });
              break;
            }
            case WS172: {
              // 固有テーブル表示
              // 再表示時にソート状態が残ることがあるためkeyを付与して再描画
              this.isWs172 = true, this.ws172TableRenderKey += 1;
              this.recollectedData = resWorkSupport.data?.project?.ws172_activation_histories || [];
              this.$nextTick(() => {
                this.measuredDataItems = this.recollectedData.map(item => ({
                  no: item.number,
                  timestamp_local: this.convertLocalDateTime(item.timestamp),
                  activation_cause_code: item.activation_cause_code,
                  reserved: item.reserved
                })).sort((a, b) => {
                  return a.no - b.no;
                });
              });
              break;
            }
            default: {
              this.recollectedData = resWorkSupport.data.project.fd_data_list;
              const fdList = [];
              this.recollectedData.forEach((obj) => {
                const setObj = {};
                setObj.status = this.$t(`${this.i18nWsKey}.${obj.status}`);
                setObj.unique_status = obj.status;
                // FD一覧に表示する発生日時を取得するため、FDのDID変換後の値を表示用の値で返す処理を行う関数を呼び出す。日時の為、i18nDidKeyとハイフンフラグは指定しない
                setObj.occurrence_date = individualWorkSupportUtil.getDisplayFdData(this, '', { data_type: obj.occurrence_date_data_type, value: obj.occurrence_date });
                // WS.96, ES9 以外
                if (immutableId !== WS96 && !(immutableId === ES9 && isSpecial)) {
                  setObj.ig_on = obj.igon_time === 0 ? this.$t(`message.common_hyphen`) : obj.igon_time;
                  setObj.od_meter = obj.odmeter === 0 ? this.$t(`message.common_hyphen`) : obj.odmeter;
                }
                setObj.buttonVisible = obj.has_fd;
                // ステータスソート用のNo付与
                setObj.no = obj.no;
                fdList.push(setObj);
              });
              this.measuredDataItems = fdList;
            }
          }

          this.measuredDataItems.map(e => {
            // 一覧にフォーカス当てた際に矢印にする
            e.bgStyle = 'dtc-cursor-default';
          });
        }, (result) => {
          if (result.behaviorType === handler.behaviorTypes.logout) this.logout(this);
        });
      } finally {
        this.processing = false;
      }
    },

    /** 初期表示で必要な情報を設定 */
    async updateColumns() {
      if (this.immutableId === WS96 || (this.immutableId === ES9 && this.isSpecial)) {
        this.measuredDataColumns = [
          { name: 'status', label: 'message.header_vehicle_dtc_table_status', originalSortFunc: this.sortFdStatus },
          { name: 'occurrence_date', label: `individual.label_ws60_occurrence_time`, originalSortFunc: this.sortFdItems },
          { name: 'fd', label: `individual.header_vehicle_system_table_details_fd`, useButton: true, originalSortFunc: diagnoseResource.sortFuncFfd }
        ];
      } else if (this.immutableId === WS139) {
        this.measuredDataColumns = [
          { name: "did", label: this.$t('message.header_vehice_ffd_item'), useHtmlBind: true, originalSortFunc: this.sortDid },
          { name: "unit", label: this.$t('message.header_vehice_ffd_unit'), useHtmlBind: true },
        ];
        const cntHistory = this.$t('individual.label_table_header_history');
        for (let i = 1; i <= 3; i++) {
          this.measuredDataColumns.push({
            name: `history_${i}`,
            label: `${cntHistory}${i}`,
            useHtmlBind: true,
            originalSortFunc: this.sortOperationHistoryItems,
          });
        }
      } else if (this.immutableId === WS172) {
        this.measuredDataColumns = [
          { name: 'no', label: `${this.i18nWsKey}.label_no` },
          { name: 'timestamp_local', label: `${this.i18nWsKey}.label_timestamp`, originalSortFunc: diagnoseResource.sortDate },
          { name: 'activation_cause_code', label: `${this.i18nWsKey}.label_activation_cause_code` }
        ];
      } else {
        this.measuredDataColumns = [
          { name: 'status', label: 'message.header_vehicle_dtc_table_status', originalSortFunc: this.sortFdStatus },
          { name: 'ig_on', label: `individual.label_ws60_ig_on_count`, originalSortFunc: this.sortFdItems },
          { name: 'occurrence_date', label: `individual.label_ws60_occurrence_time`, originalSortFunc: this.sortFdItems },
          { name: 'od_meter', label: `individual.label_ws60_odometer`, originalSortFunc: this.sortFdItems },
          { name: 'fd', label: `individual.header_vehicle_system_table_details_fd`, useButton: true, originalSortFunc: diagnoseResource.sortFuncFfd }
        ];
      }
    },

    /**
     * ステータス項目 独自ソート
     */
    sortFdStatus(param) {
      if (!param.data) {
        return null;
      }
      let itemList = [];
      // 別途付与したno項目(画面非表示)でソートする
      itemList = util.sortItems(param.data, "no", param.sortDir);
      return itemList;
    },

    /**
     * 他項目(ステータス・詳細FD以外) 独自ソート
     */
    sortFdItems(param) {
      if (!param.data) {
        return null;
      }
      // 結果リスト
      let itemList = [];
      const hyphenList = [];
      param.data.forEach(element => {
        if (element[param.sortKey] !== '-') {
          itemList.push(element);
        }
        else {
          hyphenList.push(element);
        }
      });
      // 昇順・降順に関わらず、ハイフン表示は最下行に表示する
      itemList = util.sortItems(itemList, param.sortKey, param.sortDir);
      itemList = itemList.concat(hyphenList);
      return itemList;
    },

    /**
     * ステータス項目 独自ソート
     */
    sortDid(param) {
      if (!param.data) {
        return null;
      }
      let itemList = [];
      // 別途付与したsort_id(画面非表示)でソートする
      itemList = util.sortItems(param.data, "sort_index", param.sortDir);
      return itemList;
    },

    /**
     * 他項目(項目以外) 独自ソート
     */
    sortOperationHistoryItems(param) {
      if (!param.data) {
        return null;
      }
      // 結果リスト
      let itemList = [];
      let otherList = [];
      param.data.forEach(element => {
        if (element.is_registration_failure_timing) {
          itemList.push(element);
        } else {
          otherList.push(element);
        }
      });
      // 昇順・降順に関わらず、ハイフン表示は最下行に表示する
      otherList = util.sortItems(otherList, param.sortKey, param.sortDir);
      itemList = itemList.concat(otherList);
      return itemList;
    },

    /**
     * メモボタン押下.
     * DataRecollection.jsのopenMemoModalを呼び出している
     */
    async parentOpenMemoModal() {
      this.$emit('openMemoModal');
    },

    /**
     * ファイルエクスポートボタン押下
     * DataRecollection.jsのcsvExportを呼び出している
     * csvExportに一覧のカラム、Itemを引数として渡している.
     * dmtCsvExport() : WS.45/125特有
     */
    async csvExport() {
      this.processing = true;

      // ダミー処理（ファイルエクスポートが高速で終了するので、操作者に通信の発生を認識させる）
      await util.sleep(1000);

      if (this.immutableId === WS45 || this.immutableId === WS125) {
        await this.dmtCsvExport();
      } else if (this.immutableId === WS139) {
        this.$emit('csvExport', this.measuredDataColumns, this.measuredDataItems, this.recollectedData, true, false, this.immutableId);
      } else if (this.immutableId === WS172) {
        // 固有CSVエクスポート処理
        await this.ws172CsvExport();
      } else {
        this.$emit('csvExport', this.measuredDataColumns, this.measuredDataItems, this.recollectedData, false, false, this.immutableId);
      }

      this.processing = false;
    },

    /**
     * (WS.172) 固有CSVエクスポート処理
     */
    async ws172CsvExport() {
      // CSV形式：作動要因コード, 予備, タイムスタンプ(絶対日時)
      const csvRows = this.measuredDataItems.map(item => {
        const tsDate = new Date(item.timestamp_local);
        let tsStr = '';
        if (tsDate.toString() === 'Invalid Date') {
          // 不正な日付の場合、GMT文字列から作成
          tsStr = item?.timestamp_local.replace(/[-:TZ\s]/g, "").slice(2) || "";
        } else {
          // 上記以外はlocalTimeに変換
          tsStr = util.timeConverter(tsDate).replace(/[:\s/]/g, "").slice(2);
        }
        return `${item.activation_cause_code},${item.reserved},${tsStr}`;
      });
      const csvContent = csvRows.join('\n');
      const fileName = moment().format('YYYYMMDDHHmmss');
      const bomFormatData = new Uint8Array([0xEF, 0xBB, 0xBF]); // UTF-8 BOM付き
      const blob = new Blob([bomFormatData, csvContent], { type: 'text/csv;charset=utf-8' });
      const link = window.document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `${fileName}.csv`;
      link.style.display = 'none';
      link.click();
      link.remove();
    },

    /**
     * グラフ項目件数を変更
     * @param {number} checkLines チェック数
     */
    changeCheckValue(checkLines) {
      this.dataMonitor.checkLines = checkLines;
    },

    /** ズーム/パン状態を更新 */
    zoomPanStateChanged(isActive) {
      this.isZoomPanActive = isActive;
    },

    /** 選択項目の言語変更データ受取 */
    changeSelectedFuncs(list) {
      const selectedFuncsHash = {};
      for (const selectedFunction of list) {
        const { data_monitor_id, ...conv } = selectedFunction;
        selectedFuncsHash[data_monitor_id] = conv;
      }
      this.selectedFuncs = list;
      this.selectedFunctionHash = selectedFuncsHash;
    },

    /**
     * グラフ設定情報を保持
     * @param {number} xRange 横軸設定
     * @param {object} yRange 縦軸設定
     * @param {object} lineSetting ライン設定
     */
    setGraphConfig(xRange, yRange, lineSetting) {
      this.dataMonitor.graphConfigInfo.xRange = xRange;
      // yRangeに項目が存在していれば更新、存在しなければ追加、設定済みの項目はそのまま
      Object.keys(yRange).forEach((did) => { this.dataMonitor.graphConfigInfo.yRange[did] = yRange[did]; });
      // lineSettingに項目が存在していれば更新、存在しなければ追加、設定済みの項目はそのまま
      if (lineSetting) {
        Object.keys(lineSetting).forEach((did) => {
          this.dataMonitor.graphConfigInfo.lineSetting[did] = lineSetting[did];
        });
      }
    },

    /**
     * グラフ設定ボタン押下
     */
    handleConfigureGraph() {
      this.$refs.data_monitor_measure.handleConfigureGraph();
    },

    /**
     * 詳細FDボタン押下.
     * DataRecollection.jsのdetailFDModalを呼び出している
     * @param {Array} row 一覧の選択した行
     */
    async rowButtonClickEvent(row) {
      await this.openDetailFDModal(row);
    },

    /**
     * 親のopenDetailFDModalを実行する
     * @param {Object} arg 一覧の選択した行
     */
    openDetailFDModal(arg) {
      this.$emit('openDetailFDModal', arg);
    },

    /** (WS.45) DTC表示 */
    async openDetailDtcModal() {
      try {
        if (this.isDiagInitial) {
          // 初回実行のみデータ取得
          this.isDiagInitial = false;
          this.processing = true;
          // バックエンドAPI GETのみ
          const params = { region_info: this.cachedProjectDataSource };
          this.getDiagMeasuredDataResponse = await apiService.getParamCall(
            apiService.DIAG,
            `/diagDtc/${this.projectId}/${this.linkedIds.dtc}/dtc/${this.system}`,
            params,
            this.operationScreen
          );
          // APIレスポンスの検証
          handler.validate(
            handler.validateTypes.all,
            this.getDiagMeasuredDataResponse,
            this,
            null,
            () => {
              // 正常コールバック
              if (this.getDiagMeasuredDataResponse) {
                // DTC表示画面を表示
                this.isDetailDtc = true;
                // DTC表示画面の更新
                this.$nextTick(() => {
                  this.$refs.detail_dtc_modal.updateDetailDtcTable(this.getDiagMeasuredDataResponse.data.data);
                });
              }
            },
            (result) => {
              // レスポンス不正時のコールバック
              if (result.behaviorType === handler.behaviorTypes.logout) this.logout(this);
            });
        } else {
          if (this.getDiagMeasuredDataResponse) {
            // DTC表示画面を表示
            this.isDetailDtc = true;
            // DTC表示画面の更新
            this.$nextTick(() => {
              this.$refs.detail_dtc_modal.updateDetailDtcTable(this.getDiagMeasuredDataResponse.data.data);
            });
          }
        }
      } finally {
        this.processing = false;
      }
    },

    /**
    * (WS.45) DTC画面の状態変更 子コンポーネントからemit
    * @param {*} phase DTC画面の状態
    */
    async dtcModalPhaseChange(phase) {
      this.dtcModalPhase = phase;
    },

    /** (WS.45) DTC画面の再表示 */
    dtcModalProcess() {
      this.$refs.detail_dtc_modal.dtcModalProcess();
    },

    /** (WS.45) DTC画面を非表示にする */
    closeDtcModal() {
      this.isDetailDtc = false;
    },

    /** (WS.45) モニタテスト表示 */
    async openDetailMonitorTestModal() {
      try {
        if (this.linkedIds.onboard_monitor_test === "null") {
          // モニタテスト結果を表示
          this.isMonitorTest = true;
          // テーブル更新
          this.$nextTick(() => {
            this.$refs.detail_monitor_test_modal.updateDetailMonitorTestTable([]);
          });
        } else if (this.isMonitorTestInitial) {
          this.isMonitorTestInitial = false;
          this.processing = true;
          const params = { region_info: this.cachedProjectDataSource };
          this.getMonitorTestDataResponse = await apiService.getParamCall(
            apiService.OBD,
            `/obd/${this.linkedIds.obd}/measures/${this.linkedIds.onboard_monitor_test}/onboardMonitorTest`,
            params,
            this.operationScreen
          );
          // APIレスポンスの検証
          handler.validate(
            handler.validateTypes.all,
            this.getMonitorTestDataResponse,
            this,
            null,
            () => {
              // モニタテスト結果を表示
              this.isMonitorTest = true;
              if (this.immutableId === 4501) {
                this.filteredMonitorTestResult = this.getMonitorTestDataResponse.data.user_data.results.filter(item => {
                  return MID_TID_PAIRS.some(pair => item.mid === pair[0] && item.tid === pair[1]);
                });
              } else {
                this.filteredMonitorTestResult = this.getMonitorTestDataResponse.data.user_data.results.filter(item => {
                  return MONITOR_TEST_DTC.some(code => code === item.code);
                });
              }
              // テーブル更新
              this.$nextTick(() => {
                this.$refs.detail_monitor_test_modal.updateDetailMonitorTestTable(this.filteredMonitorTestResult, this.immutableId);
              });
            },
            (result) => {
              // レスポンス不正時のコールバック
              if (result.behaviorType === handler.behaviorTypes.logout) this.logout(this);
            });
        } else {
          // モニタテスト結果を表示
          this.isMonitorTest = true;
          // テーブル更新
          this.$nextTick(() => {
            this.$refs.detail_monitor_test_modal.updateDetailMonitorTestTable(this.filteredMonitorTestResult, this.immutableId);
          });
        }
      } catch {
        // noop
      } finally {
        this.processing = false;
      }
    },

    /** (WS.45) モニタテスト画面を非表示にする */
    closeMonitorTestModal() {
      this.isMonitorTest = false;
    },

    /**
     * (WS.45) 戻るボタン押下時
     * DataRecollection.jsのbackToDetailsを呼び出している
     */
    backSelect() {
      this.$emit('backToDetails');
    },

    /**
    * (WS.139) GMTからLocalTimeへ変換
    * @param {*} responseDate 絶対時間タイプスタンプ情報
    */
    convertLocalDateTime(responseDate) {
      if (!responseDate) {
        return '-';
      }

      const globalDate = new Date(responseDate);
      // 日付として無効な文字列の場合Backendから帰ってきた文字列をそのまま表示する
      if (globalDate.toString() === 'Invalid Date') {
        return responseDate;
      }

      // LocalTimeに変換
      return util.timeConverter(globalDate);
    },

    /**
     * ファイルエクスポートボタン押下時の処理
     */
    dmtCsvExport() {
      // CSV用の文字列作成
      const descriptionStr = this.createCsvDescription();
      const headerStr = this.createCsvHeader();
      const dataStr = this.createCsvData();

      // CSVファイル作成
      const fileName = getCsvFileName(
        this.$t('individual.individual_diagnosis_function_work_support'),
        this.measuredDataName,
        this.cachedDetails.information.vin || ''
      );

      util.csvFileExport(descriptionStr + headerStr + dataStr, fileName);
    },

    /**
     * CSVのヘッダー上部の計測時の情報の文字列を作成
     * @returns {string} CSVのヘッダー上部の内容の文字列
     */
    createCsvDescription() {
      const targetMeasurement = this.cachedDetails.measures[0][apiService.WSP].find(measure => measure.registered_at.toString() === this.measuresId);

      const dataName = targetMeasurement.name || '';
      const memo = targetMeasurement.note || '';
      const vin = this.cachedDetails.information.vin || '';
      const registrationNumber = (this.cachedDetails.area_name ? this.cachedDetails.area_name + ' ' : '')
        + (this.cachedDetails.category ? this.cachedDetails.category + ' ' : '')
        + (this.cachedDetails.hiragana ? this.cachedDetails.hiragana + ' ' : '')
        + (this.cachedDetails.individual_number ? this.cachedDetails.individual_number + ' ' : '');
      const vehicleName = this.cachedDetails.information.vehicle_name || '';
      // 再生画面ではvehicleInfoのtypeが取得できないため、VINのフォーマットから判定
      const isVin = vehicle.isVinType(vin);
      const vehicleType = (isVin ? this.cachedDetails.information.model_year : this.cachedDetails.information.classification) || '';

      const dataNameDescription = `"${this.$t('individual.header_data_monitor_data_name')}",${util.escapeForCsv(dataName)}`;
      const memoDescription = `"${this.$t('individual.label_memo')}",${util.escapeForCsv(memo)}`;
      const vinDescription = `"${this.$t('individual.header_data_monitor_vin')}",${isVin ? util.escapeForCsv(vin) : util.escapeForCsv('')}`;
      // vinの種類によって表示する行を変える
      const frameNumberDescription = `"${this.$t('individual.header_data_monitor_frame_number')}",${isVin ? util.escapeForCsv('') : util.escapeForCsv(vin)}`;
      const registrationNumDescription = `"${this.$t('individual.header_data_monitor_registration_number')}",${util.escapeForCsv(registrationNumber)}`;
      const vehicleNameDescription = `"${this.$t('individual.header_data_monitor_vehicle_name')}",${util.escapeForCsv(vehicleName)}`;
      const vehicleTypeDescription = `"${this.$t('individual.header_data_monitor_vehicle_type')}",${util.escapeForCsv(vehicleType)}`;
      const ecuNameDescription = `"${CSV.ECU_DECORATION} ${this.$t(DIAG_SYSTEM + this.system)} ${CSV.ECU_DECORATION}"`;

      return [
        dataNameDescription, memoDescription, vinDescription, frameNumberDescription, registrationNumDescription, vehicleNameDescription, vehicleTypeDescription, ecuNameDescription
      ].join(CSV.LINE_BREAK) + CSV.LINE_BREAK;
    },

    /**
     * CSVのヘッダーの文字列を作成
     * @returns {string} CSVのヘッダーの内容の文字列
     */
    createCsvHeader() {
      let firstHeader = this.dataMonitor.displayTargets.map(item => `"${this.dataMonitor.selectedFunctionHash[item.data_monitor_id].menu_title}"`);
      firstHeader.unshift(`"${this.$t('individual.header_data_monitor_time')}"`, `"${this.$t('individual.header_data_monitor_mark')}"`);
      firstHeader = firstHeader.join(',');

      let secondHeader = this.dataMonitor.displayTargets.map((item) => {
        const unitPrefix = this.dataMonitor.conversionList[item.data_monitor_id].is_obd ? `obd_unit.` : `didUnit.`;
        return `"${this.$t(unitPrefix + this.dataMonitor.conversionList[item.data_monitor_id].unit_id)}"`;
      });
      secondHeader.unshift(`"${this.$t('individual.header_data_monitor_time_unit')}"`, `"${this.$t('individual.header_data_monitor_mark_unit')}"`);
      secondHeader = secondHeader.join(',');

      return firstHeader + CSV.LINE_BREAK + secondHeader + CSV.LINE_BREAK;
    },

    /**
     * CSVのデータ部の文字列を作成
     * @returns {string} CSVのデータ部の内容の文字列
     */
    createCsvData() {
      // マーク列に設定するマーカー番号
      let markerCount = 0;

      const csvData = [];
      // CSV全体の行ごとのループ
      for (let i = 0; i < this.dataMonitor.displayTargets[0].data_records.length; i++) {
        const rowData = [];
        // 1行の列ごと（計測項目ごと）のループ
        this.dataMonitor.displayTargets.forEach(item => {
          let value = null;
          const monitorId = dmUtil.splitSystemAndItemId(item.data_monitor_id)[1];
          if (item.data_type === "Value") {
            value = item.data_records[i].converted_data.toFixed(item.digits_after_decimal);
          } else if (item.data_type === "FLG" || item.data_type === "HEX") {
            value = this.$t(`${this.i18nWsDidKey}.${monitorId}_${item.data_records[i].converted_data}`);
          } else {
            value = null;
          }
          rowData.push(
            `"${value}"`
          );
        });

        // マーカがあればインクリメントして値をセット
        if (this.savedMarkerInfo.some(marker => marker.uuid === this.dataMonitor.displayTargets[0].data_records[i].time)) {
          markerCount++;
          rowData.unshift(`"${markerCount}"`);
        } else {
          rowData.unshift(`"0"`);
        }

        // TIME列はデータポイントの時刻ではなく経過時間のため、基準時刻を引く
        const time = this.dataMonitor.displayTargets[0].data_records[i].time - this.dataMonitor.baseTime;
        rowData.unshift(`"${time}"`);

        csvData.push(rowData.join(',') + CSV.LINE_BREAK);
      }
      return csvData.join('');
    },

    /** ダウンロード処理 */
    async downloadFile() {
      try {
        this.processing = true;
        // ダウンロードファイルパス取得
        let downloadFilePath = '';
        switch (this.immutableId) {
          case WS138:
            downloadFilePath = this.WS138.filePath;
            break;
          case WS148:
            downloadFilePath = this.WS148.filePath;
            break;
          default:
            break;
        }
        // ファイルダウンロード共通処理
        await individualWorkSupportUtil.downloadFile(downloadFilePath, null, this.cachedProjectDataSource);
      } catch (error) {
        alert.showError(this, null, error.message,
          () => {
            if (error.behaviorType === handler.behaviorTypes.logout) {
              this.logout(this);
            }
          });
      } finally {
        this.processing = false;
      }
    },
  },

  computed: {
    ...mapState({
      language: state => state.systems.language,
      individualMenus: (state) => state.vehicle.individualMenus,
      cachedDetails: state => state.cache.projectDetails,
      companyId: state => state.userProperty.companyId,
      region: state => state.userProperty.region,
      userId: (state) => state.userProperty.userId,
      cachedProjectDataSource: state => state.cache.projectDataSource,
    }),

    // 診断系のAPIは複数画面から使用されているため
    // 現在の画面で使用されるAPIが診断/データ再生/個別診断/OBDシステムのうちどの機能なのか判別する
    operationScreen() {
      return diagnoseResource.operationFrom(this.$router.currentRoute.value.name);
    },

    // データモニタ画面 グラフ設定ボタン押下可否
    isGraphConfigButtonDisable() {
      return !this.dataMonitor?.checkLines || this.isZoomPanActive;
    },

    // データモニタ画面 リセットズームボタン押下可否
    isResetZoomButtonDisable() {
      return isResetZoomDisabled({
        inPlaying: this.inPlaying,
        hasCheckLines: Boolean(this.dataMonitor?.checkLines),
        currentTab: this.currentTab,
      });
    },

    /** 計測データ名 */
    measuredDataName() {
      let measuredDataName = '';
      if (this.cachedDetails?.measures) {
        const targetMeasurement = this.cachedDetails.measures[0][apiService.WSP].find(measure => measure.registered_at.toString() === this.measuresId);
        measuredDataName = targetMeasurement ? targetMeasurement.name : '';
      }
      return measuredDataName;
    }
  },

  async created() {
    // SBRユーザーかチェック
    this.isSBRUser = await this.checkSBRUser(this.companyId);
  },
};